
    import '/mnt/src/components/NavBar/index.md?watch=parent';
    export const demoIndex = {
  ids: ["navbar-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/NavBar/index.md?type=demo')
};